import StaticNonStaticMapBaseLoadable from './StaticNonStaticMapBaseLoadable.js';

/**
 * Static Map, not user movable
 * 	- Centres of the position as specified in lat, lng with zoom level set
 * 			OR
 *  - If geoJSON is passed, centres on the polygons within the geoJSON
 */
const StaticMap = ({ children, lat, lng, noPopup, noDefaultMarker, zoom = 13, label, style, geoJSON, additionalCustomGeoJSON, inhibitAttribForTinySize = false }) => {
    return <StaticNonStaticMapBaseLoadable
        lat={lat}
        lng={lng}
        noPopup={noPopup}
        noDefaultMarker={noDefaultMarker}
        zoom={zoom}
        label={label}
        style={style}
        geoJSON={geoJSON}
        additionalCustomGeoJSON={additionalCustomGeoJSON}
        zoomControl={false} 
        scrollWheelZoom={false} 
        dragging={false} 
        touchZoom={false}
        inhibitAttribForTinySize={inhibitAttribForTinySize}
    >{children}</StaticNonStaticMapBaseLoadable>
};

export default StaticMap;
